var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":_vm.modalId,"title":_vm.storeTitle,"hide-footer":"","size":"lg"}},[_c('StoreInfos',{attrs:{"storeId":_vm.storeId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }